/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: [2, { "props": false }] */
import * as types from '../mutations/app';

const state = {
  errorFlashs: [],
  activities: [],
  checkSessionCount: 0,
  isContentLoading: false,
  appMode: '',
};
const getters = {
  activityCount(state) {
    return state.activities.length;
  },
  checkSessionCount(state) {
    return state.checkSessionCount;
  },
  errorFlashs(state) {
    return state.errorFlashs;
  },
  isContentLoading(state) {
    return state.isContentLoading;
  },
  appMode(state) {
    return state.appMode;
  },
  appName(state) {
    return state.appMode === 'admin' ? 'Admin Panel' : '';
  },
  isAdmin(state) {
    return state.appMode === 'admin';
  },
  isBiller(state) {
    return state.appMode === 'biller';
  },
};
const actions = {
  APP_CLEAR_STATE({ commit }) {
    return new Promise((resolve) => {
      commit(types.APP_STATE_CLEARED);
      resolve();
    });
  },
  ADD_ACTIVITY({ commit }, activity) {
    return new Promise((resolve) => {
      commit(types.ACTIVITY_ADDED, activity);
      resolve();
    });
  },
  CLEAR_ACTIVITY({ commit }) {
    return new Promise((resolve) => {
      commit(types.ACTIVITY_CLEARED);
      resolve();
    });
  },
  ADD_SESSION_COUNT({ commit }) {
    return new Promise((resolve) => {
      commit(types.SESSION_COUNT_ADDED);
      resolve();
    });
  },
  CLEAR_SESSION_COUNT({ commit }) {
    return new Promise((resolve) => {
      commit(types.SESSION_COUNT_CLEARED);
      resolve();
    });
  },
  ADD_ERROR_FLASH({ commit }, errMessage) {
    return new Promise((resolve) => {
      commit(types.ERROR_FLASH_ADDED, errMessage);
      resolve();
    });
  },
  CLEAR_ERROR_FLASH({ commit }) {
    return new Promise((resolve) => {
      commit(types.ERROR_FLASH_CLEARED);
      resolve();
    });
  },
  START_CONTENT_LOADING({ commit }) {
    return new Promise((resolve) => {
      commit(types.CONTENT_LOADING);
      resolve();
    });
  },
  STOP_CONTENT_LOADING({ commit }) {
    return new Promise((resolve) => {
      commit(types.CONTENT_LOADED);
      resolve();
    });
  },
  SET_APP_MODE({ commit }, mode) {
    return new Promise((resolve) => {
      commit(types.APP_MODE_SET, mode);
      resolve();
    });
  },
};
const mutations = {
  [types.ACTIVITY_ADDED](state, activity) {
    state.activities.push(activity);
  },
  [types.ACTIVITY_CLEARED](state) {
    // delete all stuffs in the array including related reference object
    state.activities.splice(0);
  },
  [types.SESSION_COUNT_ADDED](state) {
    state.checkSessionCount += 1;
  },
  [types.SESSION_COUNT_CLEARED](state) {
    state.checkSessionCount = 0;
  },
  [types.ERROR_FLASH_ADDED](state, errMessage) {
    state.errorFlashs.push(errMessage);
  },
  [types.ERROR_FLASH_CLEARED](state) {
    // delete all stuffs in the array including related reference object
    state.errorFlashs.splice(0);
  },
  [types.CONTENT_LOADING](state) {
    state.isContentLoading = true;
  },
  [types.CONTENT_LOADED](state) {
    state.isContentLoading = false;
  },
  [types.APP_MODE_SET](state, mode) {
    state.appMode = mode;
  },
  [types.APP_STATE_CLEARED](state) {
    state.errorFlashs.splice(0);
    state.activities.splice(0);
    state.checkSessionCount = 0;
    state.isContentLoading = false;
  },
};

/**
 * App Store - Manage Application state
 */
const AppStore = {
  state,
  getters,
  actions,
  mutations,
};

export default AppStore;



// WEBPACK FOOTER //
// ./src/store/modules/app.js